import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import FindItemResponseMessage from 'owa-service/lib/contract/FindItemResponseMessage';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { logUsage } from 'owa-analytics';

/**
 * Set of logger utilities to debug WI #81596
 * Remove the file and its reference once the WI is closed.
 */

export const logLoadedConversationIds = (
    response: FindConversationResponseMessage
): FindConversationResponseMessage => {
    try {
        if (isMiniFeatureEnabled('mini-liveSite-deleteMail')) {
            if (response.ResponseClass === 'Success') {
                const ids =
                    response?.Conversations.map(
                        conversations => conversations.ConversationId?.Id
                    ) || [];
                logUsage(
                    'CI_Loaded',
                    { ids: ids.toString() },
                    { isCore: true, isCosmosDatapoint: true }
                );
            }
        }
    } catch (error) {}

    return response;
};

export const logLoadedItemIds = (response: FindItemResponseMessage): FindItemResponseMessage => {
    try {
        if (isMiniFeatureEnabled('mini-liveSite-deleteMail')) {
            if (response?.ResponseClass === 'Success') {
                const ids = response?.RootFolder?.Items.map(items => items.ItemId?.Id) || [];
                logUsage(
                    'I_Loaded',
                    { ids: ids.toString() },
                    { isCore: true, isCosmosDatapoint: true }
                );
            }
        }
    } catch (error) {}

    return response;
};
